export default __webpack_public_path__ + "images/6f0b0b21831b945f40842ddef79b4ecc-tou-texto.svg";